import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback } from 'react';
import { createTransformer } from '../core';

// FIXME: This is a hack to stop @atlassian/metal-client from complaining since MetricName is not exported

// TODO: Make a package for utilitys like this one
var selectInnerMostBreadcrumbName = function selectInnerMostBreadcrumbName(breadcrumbs) {
  var NO_BREADCRUMB_FOUND_NAME = 'none';
  if (breadcrumbs.length <= 0) {
    return NO_BREADCRUMB_FOUND_NAME;
  }
  return breadcrumbs[breadcrumbs.length - 1].name.toString();
};

// TODO: Could omit more fields in certain bridge factory methods

export var getTelemetryMetalMetricInfo = function getTelemetryMetalMetricInfo(_ref) {
  var breadcrumbs = _ref.breadcrumbs;
  var page = selectInnerMostBreadcrumbName(breadcrumbs);
  return _objectSpread({}, page === null ? null : {
    page: page
  });
};
export var createMetalEventTransformer = function createMetalEventTransformer(_ref2) {
  var from = _ref2.from,
    to = _ref2.to,
    useTransformer = _ref2.useTransformer;
  // Gotta be outside the scope otherwise hooks will keep recomputing
  var useMetalTransformer = function useMetalTransformer(transformProps) {
    var transform = useTransformer(transformProps);
    return useCallback(function (_ref3) {
      var breadcrumbs = _ref3.breadcrumbs,
        originalPayload = _ref3.payload;
      return _objectSpread(_objectSpread({}, transform(originalPayload)), getTelemetryMetalMetricInfo({
        breadcrumbs: breadcrumbs
      }));
    }, [transform]);
  };
  var ArbitraryEventToConnectedEvent = createTransformer({
    from: from,
    to: to,
    useTransformer: useMetalTransformer
  });
  return ArbitraryEventToConnectedEvent;
};
/**
 * @param startTimeRef Just a reference with a number in it.
 * This number should represent the start time of a whatever you're timing.
 */
export var getTimingMetricFieldsFromBreadcrumb = function getTimingMetricFieldsFromBreadcrumb(_ref4, startTimeRef) {
  var payload = _ref4.payload;
  var now = Date.now();
  return {
    value: now - startTimeRef.current,
    page: payload.name.toString()
  };
};
export var createBasicMetalEventTransformer = function createBasicMetalEventTransformer(input, metric) {
  return createMetalEventTransformer(_objectSpread(_objectSpread({}, input), {}, {
    useTransformer: function useTransformer() {
      return useCallback(function () {
        return metric;
      }, []);
    }
  }));
};